<template>
    <div role="tabcard" class="active tab-pane w-full" id="customSettings">
        <div class="flex justify-center my-3" v-if="loading" dusk="project-management-first-load">
            <i class="fa  fa-2x fa-spinner fa-spin text-teal"></i>
        </div>
        <div class="spark-settings-tabs w-full flex" v-if="!loading">
            <div class="mt-4 w-1/6">
                <div class="mb-2 flex-col">
                    <div class="text-sm text-grey-darkest mb-2">Project Stages</div>
                    <div v-for="item in projectStages" :key="item.id" class="mb-2">
                        <button
                            class="text-grey-darkest hover:no-underline text-base hover:text-followup-nav cursor-pointer py-1 pl-3 pr-3"
                            :dusk="'project-stage-' + item.id + '-button'"
                            :class="selectedStage.id === item.id ? 'active' : null" @click="selectedStage = item">
                            <div :class="{underline: selectedStage.id === item.id}">
                                {{ item.full_description }}
                            </div>
                        </button>
                    </div>
                </div>
                <div class="mr-4 flex-col">
                    <div>
                        <label class="text-sm text-grey-darkest">Contract Type</label>
                        <multiselect :options="contractTypes"
                                    v-model="contractType"
                                    track-by="id" label="code" class="mb-2 cursor-pointer">
                        </multiselect>
                    </div>
                </div>
            </div>
            <div class="flex-1">
                <div class="w-full">
                    <div class="tab-content">
                        <project-management-behaviors-table
                            :project-durations="projectDurations"
                            :project-stage-id="selectedStage.id"
                            :project-contract-type-id="contractType.id"
                            :project-contract-types="contractTypes"
                            :project-stage-name="selectedStage.full_description"
                            :project-stages="projectStages"
                            :no-stages="projectStages.length === 0"
                            :no-durations="projectDurations.length === 0">
                        </project-management-behaviors-table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Multiselect from 'vue-multiselect';
    export default {
        name: 'project-management-behaviors',
        components: {Multiselect},
        data() {
            return {
                loading         : true,
                selectedStage   : {id: null, full_description: null},
                projectStages   : [],
                projectDurations: [],
                contractTypes   : [],
                contractType    : {id: null, code: null},
            }
        },

        created() {
            this.fetchData();
        },

        methods: {
            fetchData() {
                this.fetchProjectStages();
                this.fetchProjectDurations();
                this.fetchContractTypes();
            },

            fetchProjectStages() {
                axios.get(route('project-management.api.settings.codes.project-stage.light'))
                    .then(({data}) => {
                        this.projectStages = data;
                        this.loading       = false;

                        if (data.length > 0) {
                            this.selectedStage = data[0];
                        }
                    });
            },

            fetchProjectDurations() {
                axios.get(route('project-management.api.settings.codes.project-duration.index')).then(({data}) => {
                    this.projectDurations = data;
                })
            },

            fetchContractTypes() {
                axios.get(route('project-management.api.settings.codes.project-contract-types.index')).then(({data}) => {
                    this.contractTypes = data;
                })
            },

            async ApplyContractTypeToAllBehaviors() {
                await axios.post(route('project-management.api.settings.codes.project-contract-types.apply-all', {
                    contract_type_id: this.contractType.id,
                    project_stage_id: this.selectedStage.id
                }))
                this.fetchData()
            }
        }
    }
</script>
